<div class="flex items-center space-x-2">
<ng-container
  *gatePermission="[
    role.GateEcommerceAdmin,
    role.GateEcommerceOrderApprover,
    role.GateEcommerceOrderRequester
  ]; match: 'any'; type: 'group'"
  >
  <gate-shopping-cart-menu [mobileFullViewTrigger]="mobileFullView"
    (openCartFullView)="openCartFullView.emit()" />
  </ng-container>
  <button class="icon-with-circle icon-with-circle-lg" id="setting-menu"
    (click)="openSettingsMenu($event, settingMenu)"> <i class="pi pi-cog"></i></button>

  </div>
  <p-menu #settingMenu [model]="settings" [popup]="true" appendTo="body" styleClass="p-1 w-[280px] right-[-40px]">
    <ng-template #item let-item>
      @if (item.isToggleOption) {
        @if (item.isThemeColorToggle) {
          <a class="flex items-center justify-between p-menu-item-link text-sm p-1 h-8" [id]="item.testid">
            <span>{{ item.label }}</span>
            <span class="flex items-center justify-between" style="width: 90px;">
              <i class="pi pi-moon"></i>
              <p-toggleswitch [(ngModel)]="isLightMode" (onChange)="toggleDarkMode()" />
              <i class="pi pi-sun"></i>
            </span>
          </a>
        }
        @if (item.isLangToggle) {
          <a class="flex items-center justify-between p-menu-item-link text-sm p-1 h-8" [id]="item.testid">
            <span>{{ item.label }}</span>
            <span class="flex items-center justify-between" style="width: 90px;">
              <i>{{'menu.language.en' | translate}}</i>
              <p-toggleswitch (onChange)="toggleLanguage()" [ngModel]="locale() == 'en-US' ? false : true" />
              <i>{{'menu.language.de' | translate}}</i>
            </span>
          </a>
        }
        @if (item.isHeroToggle) {
          <a class="flex items-center justify-between p-menu-item-link text-sm p-1 h-8" [id]="item.testid">
            <span>{{ item.label }}</span>
            <span class="flex items-center justify-center" style="width: 90px;">
              <p-toggleswitch [ngModel]="isHeroVisible()" (onChange)="toggleHeroVisibility($event.checked)" />
            </span>
          </a>
        }
      } @else if (item.routerLink) {
          <a [routerLink]="item.routerLink" class="flex align-items-center p-menu-item-link text-sm p-1 h-8" [id]="item.testid">
            <span> @if (item.icon) {
              <i [class]="item.icon" class="text-brand">&nbsp;</i>
            }{{ item.label }}</span>
          </a>
        } @else {
          <a [href]="item.url" [target]="item.target || '_blank'" class="flex align-items-center p-menu-item-link text-sm p-1 h-8" [id]="item.testid">
            <span>@if (item.icon) {
              <i [class]="item.icon" class="text-brand">&nbsp;</i>
            }{{ item.label }}</span>
          </a>
        }
      
    </ng-template>
  </p-menu>
